// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__dhl+T","label":"ContactForm_label__-cVXI","input":"ContactForm_input__Bl93P","formButton":"ContactForm_formButton__TN6Jq"};